import { IconButton } from './IconButton.jsx';

/** Dialog — centered modal with scrim. Renders nothing when `open` is false. */
export function Dialog({ open, onClose, title, children, footer, width = 460, style }) {
  if (!open) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-5)',
        background: 'rgba(16, 42, 56, 0.42)', backdropFilter: 'blur(3px)',
        animation: 'sq-fade var(--dur-base) var(--ease-out)',
      }}
    >
      <div
        role="dialog" aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%', maxWidth: width, maxHeight: '90vh', overflow: 'auto',
          background: 'var(--surface-card)', borderRadius: 'var(--radius-xl)',
          boxShadow: 'var(--shadow-lg)', border: '2px solid var(--border)',
          animation: 'sq-pop var(--dur-slow) var(--ease-bounce)',
          ...style,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16, padding: 'var(--space-5) var(--space-5) 0' }}>
          {title && <h2 style={{ margin: 0, fontFamily: 'var(--font-display)', fontWeight: 'var(--fw-semibold)', fontSize: 'var(--text-xl)', color: 'var(--text-strong)' }}>{title}</h2>}
          {onClose && <IconButton icon="x" label="Close" size="sm" onClick={onClose} />}
        </div>
        <div style={{ padding: 'var(--space-4) var(--space-5)', fontFamily: 'var(--font-sans)', fontSize: 'var(--text-base)', color: 'var(--text-body)', lineHeight: 'var(--lh-normal)' }}>
          {children}
        </div>
        {footer && <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '0 var(--space-5) var(--space-5)' }}>{footer}</div>}
      </div>
      <style>{`@keyframes sq-fade{from{opacity:0}to{opacity:1}}@keyframes sq-pop{from{opacity:0;transform:translateY(12px) scale(.96)}to{opacity:1;transform:none}}`}</style>
    </div>
  );
}
